<script lang="ts">
export default { name: 'PinRestoreCode' };
</script>

<script lang="ts" setup>
// COMPONENTS
import { GButton } from '@flash-global66/g-button';
import { GInputCode } from '@flash-global66/g-input-code';
import { GImage } from '@flash-global66/g-image';
import GStepGrid from '@/components/GStepper/components/GStepGrid.vue';
import { usePinRestoreCode } from './usePinRestoreCode';
import type { PinEmits } from '../../types/pin.type';

const emits = defineEmits<PinEmits>();

const {
  pin,
  repeat,
  isDisabled,
  isTypeChange,
  getTitleText,
  getSubtitleText,
  onClose,
  onKeyPressToValidate,
  onCompletePin,
  onChangePin,
  onCompletePinRepeat,
  onChangePinRepeat,
  onNext,
} = usePinRestoreCode(emits);
</script>

<template>
  <g-step-grid :class="{ 'pt-14': isTypeChange }" data-test="pin:restore-code">
    <template #content>
      <div class="flex flex-col items-center my-12">
        <GImage name="lock" size="lg" />
        <h3
          class="text-center mt-md pb-md text-6 md:text-8 text-primary-txt font-semibold leading-tight"
        >
          {{ getTitleText() }}
        </h3>
        <p class="text-3 mb-xl md:text-5 text-secondary-txt md:font-medium">
          {{ getSubtitleText() }}
        </p>

        <g-input-code
          class="mb-10"
          password
          :text-error="pin.error"
          @complete="onCompletePin"
          @change="onChangePin"
          data-test="input:pin-primary"
        />

        <div class="">
          <div class="text-gray-2 mb-1">Confirma tu PIN</div>
          <g-input-code
            password
            :text-error="repeat.error"
            @complete="onCompletePinRepeat"
            @change="onChangePinRepeat"
            @validate="onKeyPressToValidate()"
            data-test="input:pin-secondary"
          />
        </div>
      </div>
    </template>

    <template #actions>
      <section class="flex justify-center">
        <g-button
          v-if="isTypeChange"
          class="mr-3"
          variant="tertiary"
          data-test="button:close"
          @click="onClose"
        >
          Cancelar
        </g-button>
        <g-button
          class="px-14"
          :disabled="isDisabled"
          @click="onNext"
          data-test="button:continue"
        >
          {{ isTypeChange ? 'Cambiar' : 'Continuar' }}
        </g-button>
      </section>
    </template>
  </g-step-grid>
</template>
